import { useDispatch } from "react-redux";
import type { Dispatch } from "../index";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
const useAppDispatch: () => Dispatch = useDispatch;
export default useAppDispatch;
